import React from "react";

import { Div } from "Common/HTML";

import type { StyleProps } from "Utils/styleProps";

import makeBem from "Utils/makeBem";

// The BEM element classNames are copied from Intuit's 'Basic' spinner HTML structure:
// https://designsystem.quickbooks.com/storybook/?path=/story/spinner-indeterminate-long--all
const bem = makeBem("IntuitSpinner");

const GrowerContainer = () => (
  <Div className={bem("growerContainer")}>
    <Div className={bem("grower")}>
      <Div className={bem("rotatorMask")}>
        <Div className={bem("rotator")}>
          <Div className={bem("halfCircle")} />
        </Div>
      </Div>
    </Div>
  </Div>
);

const Spinner = (props: StyleProps) => (
  <Div className={bem("wrapper")} {...props}>
    <Div className={bem("growerRotation")}>
      <GrowerContainer />
      <GrowerContainer />
      <GrowerContainer />
      <GrowerContainer />
    </Div>
    <Div className={bem("spinner")}>
      <Div className={bem("oscillatorMask")}>
        <Div className={bem("oscillator")}>
          <Div className={bem("halfCircle")} />
        </Div>
      </Div>
      <Div className={bem("oscillatorMask")}>
        <Div className={bem("oscillator")}>
          <Div className={bem("halfCircle")} />
        </Div>
      </Div>
    </Div>
  </Div>
);

export default Spinner;
